import request from '@/utils/request'
import servers from '@/config/servers'

/**
 * request 请求参数
 * (
 *    http method, http 请求方法
 *    request relate path, 请求的相对路径
 *    server, 请求的服务，来源于 servers
 *    params, 请求参数
 *    need token 是否需要 token
 * )
 */

/* 从设备端服务获取数据 BEGIN */
// 获取老师从设备端登录的 Token
export async function queryToken (params) {
  return request('POST', '/teacher/auth/login', servers.device, params, false)
}

// 信息屏
export async function queryBanner () {
  return request('GET', '/device/infoBanners', servers.device)
}

// 获取班级列表
export async function queryClass (params) {
  return request('GET', '/teacher/schoolClasses', servers.device, params)
}

// 获取班级学生列表
export async function queryClassStudent (params) {
  return request('GET', '/teacher/classStudents', servers.device, params)
}
/* 从设备端服务获取数据 END */

/* 从 wps 端和移动端服务获取数据 BEGIN */
// 获取乐器类别
export async function queryInstrumentCategories (params) {
  return request('GET', '/wps/instrumentCategories', servers.user, params)
}

// 获取乐器列表
export async function queryInstruments (params) {
  return request('GET', '/wps/instruments', servers.user, params)
}

// 获取乐器详情
export async function queryInstrumentsDetails (id, params = {}) {
  return request('GET', `/preview/instruments/${id}`, servers.user, params)
}

// 获取音乐家类别
export async function queryMusiciansCategories (params) {
  return request('GET', '/wps/musicianCategories', servers.user, params)
}

// 获取音乐家列表
export async function queryMusicians (params) {
  return request('GET', '/wps/musicians', servers.user, params)
}

// 获取音乐家详情
export async function queryMusiciansDetails (id, params = {}) {
  return request('GET', `/preview/musicians/${id}`, servers.user, params)
}

// 获取乐理知识列表
export async function queryMusicTheories (params = {}) {
  return request('GET', '/wps/musicTheories', servers.user, params)
}

// 获取乐理知识详情
export async function queryMusicTheoryDetail (id, params = {}) {
  return request('GET', `/preview/musicTheory/${id}`, servers.user, params)
}

// 获取KTV歌曲详情
export async function queryKtvSongs (id, params = {}) {
  return request('GET', `/preview/ktvSongs/${id}`, servers.user, params)
}

// 获取教材歌曲详情
export async function queryEduSongs (id, params = {}) {
  return request('GET', `/preview/songs/${id}`, servers.user, params)
}

// 获取课件详情
export async function querycursewaresDetail (id, params = {}) {
  return request('GET', `/preview/coursewares/${id}`, servers.user, params)
}

// 预览页面获取律动详情
export async function queryPreviewUserMelodyDetail (id, params = {}) {
  return request('GET', `/preview/userMelodyFiles/${id}`, servers.user, params)
}
/* 从 wps 端和移动端服务获取数据 END */

/* 从后台（音乐教学平台）服务获取数据 BEGIN */
// 获取音乐律动配置文件
export async function queryMlodyGestureType (params) {
  return request('GET', '/backend/melodyGestureTypes', servers.platform, params)
}

// 获取 OSS 配置
export async function queryOSSConfig (params = {}) {
  return request('GET', '/backend/oss-sts', servers.platform, params)
}

// 上传律动文件
export async function queryUserMelodyFiles (params = {}) {
  return request('POST', '/backend/userMelodyFiles', servers.platform, params)
}

// 获取律动详情
export async function queryUserMelodyDetail (id, params = {}) {
  return request('GET', `/backend/userMelodyFiles/${id}`, servers.platform, params)
}

// 更新律动详情
export async function queryUpdateMelodyDetail (id, params = {}) {
  return request('PUT', `/backend/userMelodyFiles/${id}`, servers.platform, params)
}

// 获取电子教材信息
export async function queryEbookInfo (params = {}, token = '', server = servers.platform) {
  const url = server === 'platform' ? '/backend/digital-book/course/show' : '/device/digitalBook/course/show'
  return request('GET', url,
    server, params, true,
    { Authorization: `Bearer ${token}` })
}

export async function getAllMelodyGesture (params) {
  return request('GET', '/backend/melodyGesture', servers.platform, params)
}

export async function createMelodyGesture (params) {
  return request('POST', '/backend/melodyGesture/create', servers.platform, params)
}

export async function delMelodyGesture (id) {
  return request('DELETE', `/backend/melodyGesture/delete/${id}`, servers.platform)
}
/* 从后台（音乐教学平台）服务获取数据 END */
